<template>
  <div class="row row-cols-1 row-cols-xl-4">
    <div class="col p-1">
      <div class="card shadow-none mb-0" style="height: 80px">
        <div class="card-body ms-2">
          <h5 class="mb-2 ">Balance</h5>
          <h4 v-if="u !== undefined && u.A !== undefined"
            :class="{ 'text-success': u !== undefined && u.A !== undefined && u.A > 0, 'text-danger': u !== undefined && u.A !== undefined && u.A <= 0 }">
            {{ u.A.toLocaleString() }}</h4>
          <!-- <img src="assets/images/cat/01.png" class="position-absolute end-0 bottom-0" width="140" alt="" /> -->
        </div>
      </div>
    </div>
    <div class="col p-1">
      <div class="card shadow-none mb-0" style="height: 80px">
        <div class="card-body ms-2">
          <h5 class="mb-2 ">Exposure</h5>
          <h4 v-if="u !== undefined && u.L !== undefined"
            :class="{ 'text-success': u !== undefined && u.L !== undefined && u.L >= 0, 'text-danger': u !== undefined && u.L !== undefined && u.L < 0 }">
            {{ u.L.toLocaleString() }}</h4>
          <!-- <img src="assets/images/cat/01.png" class="position-absolute end-0 bottom-0" width="140" alt="" /> -->
        </div>
      </div>
    </div>
    <div class="col p-1">
      <div class="card shadow-none mb-0" style="height: 80px">
        <div class="card-body ms-2">
          <h5 class="mb-2 ">Credit Pts</h5>
          <h4 v-if="u !== undefined && u.C !== undefined"
            :class="{ 'text-success': u !== undefined && u.C !== undefined && u.C > 0, 'text-danger': u !== undefined && u.C !== undefined && u.C <= 0 }">
            {{ u.C.toLocaleString() }}</h4>
          <!-- <img src="assets/images/cat/01.png" class="position-absolute end-0 bottom-0" width="140" alt="" /> -->
        </div>
      </div>
    </div>
    <div class="col p-1">
      <div class="card shadow-none mb-0" style="height: 80px">
        <div class="card-body ms-2">
          <h5 class="mb-2 ">Credit Pts Available</h5>
          <h4 v-if="u !== undefined && u.Cr !== undefined"
            :class="{ 'text-success': u !== undefined && u.Cr !== undefined && u.Cr > 0, 'text-danger': u !== undefined && u.Cr !== undefined && u.Cr <= 0 }">
            {{ u.Cr.toLocaleString() }}</h4>
          <!-- <img src="assets/images/cat/01.png" class="position-absolute end-0 bottom-0" width="140" alt="" /> -->
        </div>
      </div>
    </div>
    <div class="col p-1">
      <div class="card shadow-none mb-0" style="height: 80px">
        <div class="card-body ms-2">
          <h5 class="mb-2 ">Down Pts</h5>
          <h4 v-if="u !== undefined && u.D !== undefined"
            :class="{ 'text-success': u !== undefined && u.D !== undefined && u.D > 0, 'text-danger': u !== undefined && u.D !== undefined && u.D <= 0 }">
            {{ u.D.toLocaleString() }}</h4>
          <!-- <img src="assets/images/cat/01.png" class="position-absolute end-0 bottom-0" width="140" alt="" /> -->
        </div>
      </div>
    </div>
    <div class="col p-1">
      <div class="card shadow-none mb-0" style="height: 80px">
        <div class="card-body ms-2">
          <h5 class="mb-2 ">Our Pts</h5>
          <h4 v-if="u !== undefined && u.O !== undefined"
            :class="{ 'text-success': u !== undefined && u.O !== undefined && u.O > 0, 'text-danger': u !== undefined && u.O !== undefined && u.O <= 0 }">
            {{ u.O.toLocaleString() }}</h4>
          <!-- <img src="assets/images/cat/01.png" class="position-absolute end-0 bottom-0" width="140" alt="" /> -->
        </div>
      </div>
    </div>
    <div class="col p-1" v-if="u !== undefined && u.U !== undefined && u.U !== 0">
      <div class="card shadow-none mb-0" style="height: 80px">
        <div class="card-body ms-2">
          <h5 class="mb-2 ">Upline</h5>
          <h4 v-if="u !== undefined && u.U !== undefined"
            :class="{ 'text-success': u !== undefined && u.U !== undefined && u.U < 0, 'text-danger': u !== undefined && u.U !== undefined && u.U >= 0 }">
            {{ (-1 * u.U).toLocaleString() }}</h4>
          <!-- <img src="assets/images/cat/01.png" class="position-absolute end-0 bottom-0" width="140" alt="" /> -->
        </div>
      </div>
    </div>
    <div class="col p-1" v-if="u !== undefined && u.S !== undefined && u.S !== 0">
      <div class="card shadow-none mb-0" style="height: 80px">
        <div class="card-body ms-2">
          <h5 class="mb-2 ">Our Share</h5>
          <h4 v-if="u !== undefined && u.S !== undefined"
            :class="{ 'text-success': u !== undefined && u.S !== undefined && u.S > 0, 'text-danger': u !== undefined && u.S !== undefined && u.S <= 0 }">
            {{ u.S.toLocaleString(undefined, { minimumFractionDigits: 2 })
            }}</h4>
          <!-- <img src="assets/images/cat/01.png" class="position-absolute end-0 bottom-0" width="140" alt="" /> -->
        </div>
      </div>
    </div>
    <div class="col p-1" v-if="u !== undefined && u.Us !== undefined && u.Us !== 0">
      <div class="card shadow-none mb-0" style="height: 80px">
        <div class="card-body ms-2">
          <h5 class="mb-2 ">Upline Share</h5>
          <h4 v-if="u !== undefined && u.Us !== undefined"
            :class="{ 'text-danger': u !== undefined && u.Us !== undefined && u.Us > 0 }">{{
              u.Us.toLocaleString(undefined, {
                minimumFractionDigits: 2
              }) }}</h4>
          <!-- <img src="assets/images/cat/01.png" class="position-absolute end-0 bottom-0" width="140" alt="" /> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $$vm from "@/data/index";

export default {
  name: "Home",
  data() {
    return {
      u: undefined,
    };
  },
  methods: {
    update: function () {
      var self = this;
      try {
        if ($$vm.cn) {
          $$vm.c.invoke("usadd").then(
            function (data) {
              if (data !== undefined && data !== null) {
                data = $$vm.decompress(data);
                self.u = data;
                //console.log(data);
              }
            },
            function (err) {
              setTimeout(function () {
                self.update();
              }, 500);
            }
          );
        } else {
          setTimeout(function () {
            self.update();
          }, 250);
        }
      } catch (error) {
        setTimeout(function () {
          self.update();
        }, 250);
      }
    },
  },
  mounted() {
    this.update();
  },
};
</script>

<style></style>